import IColumnData from "../../common/interface/IColumnData";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

export interface IMisDatos {
    tipoEmailId: number;
    tipoEmailNombre: string;
    email: string;
    idSync: string;
    editable: boolean;
}

export enum TipoId {
    PortalVentas = "14"
}

export interface IContactos {
    contactoId: number;
    contactoNro: string;
    nombreFantasia: string;
    nombre: string;
    email: string;
    tiendaNro: string;
    calle: string;
    calleNro: string;
    telefono: string;
    provincia: string;
    region: string;
    tiendaId: string;
}

export interface ContactoRequest {
    contactoId?: number;
    contactoNro?: string;
    nombre: string;
    telefono: string;
    clienteId?: string;
    email: string;
    tiendaId: string;
    tiendaNro?: string;
    tipoEmailId?: string;
    rolId?: number,
    visible: boolean
}

export interface ContactoDeleteRequest {
    contactoId: number;
    contactoNro?: string;
}

export const GetContactosColumns = (
    handleEdit: (row: any) => void,
    handleDelete: (row: any) => void
): IColumnData[] => [  
    {
        width: 10,
        label: 'Nombre',
        dataKey: 'nombre',
    },
    {
        width: 80,
        label: 'Email',
        dataKey: 'email'
    },
    {
        width: 80,
        label: 'Nro. Contacto',
        dataKey: 'contactoNro'
    },
    {
        width: 80,
        label: 'Teléfono',
        dataKey: 'telefono'
    },
    {
        width: 10,
        label: 'Tienda Nro.',
        dataKey: 'tiendaNro',
    },
    {
        width: 40,
        label: 'Calle',
        dataKey: 'calle',
    },
    {
        width: 40,
        label: 'Calle Nro.',
        dataKey: 'calleNro',
    },
    {
        width: 120,
        label: 'Provincia',
        dataKey: 'provincia',
    },
    {
        width: 120,
        label: 'Acciones',
        dataKey: 'acciones',
        cellRenderer: ({ rowData }: any) => (
            <>
                <IconButton onClick={() => handleEdit(rowData)} title="Editar">
                    <EditIcon style={{ color: 'red' }}/>
                </IconButton>
                <IconButton onClick={() => handleDelete(rowData)} title="Eliminar">
                    <DeleteIcon style={{ color: 'red' }}/>
                </IconButton>
            </>
        )
    }
];